export default "__VITE_ASSET__DWtVSEBM__"